import GridRoute from 'eflex/util/grid-route';
import { task } from 'ember-concurrency';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { TrackedArray } from 'tracked-built-ins';
import { action } from '@ember/object';

export default class EvisionNonConformingRoute extends GridRoute {
  @service store;

  getData = task(waitFor(async (params = {}) => {
    const results = await this.store.query('non-conforming-image', params);
    const data = new TrackedArray(results);

    data.meta = { count: results.meta?.count ?? 0 };

    return data;
  }));

  @action
  refresh(params = {}) {
    this.search.perform(params);
  }
}
